import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Room } from "./";
import { Divider } from "../";
import styles from "./styles.less";

class Rooms extends Component {
  render() {
    const {
      rooms,
      className,
      isRtl,
      titles,
      clubUserLoggedIn,
      onAddonRemove,
      globalCurrencyCode,
      propertyType,
      isMobileView
    } = this.props;

    return (
      <div
        className={cx(styles.rooms, className, {
          [styles.mobileView]: isMobileView
        })}
      >
        {rooms.map(item => {
          return (
            <React.Fragment key={item.id}>
              <Room
                key={item.id}
                className={styles.room}
                {...item}
                titles={titles}
                isRtl={isRtl}
                globalCurrencyCode={globalCurrencyCode}
                clubUserLoggedIn={clubUserLoggedIn}
                propertyType={propertyType}
                onAddonRemove={onAddonRemove}
              />

              <Divider />
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

Rooms.propTypes = {
  titles: PropTypes.object,
  className: PropTypes.string,
  rooms: PropTypes.array,
  isRtl: PropTypes.bool,
  clubUserLoggedIn: PropTypes.bool,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  globalCurrencyCode: PropTypes.string,
  propertyType: PropTypes.string,
  onAddonRemove: PropTypes.func,
  isMobileView: PropTypes.bool
};

export default Rooms;



// WEBPACK FOOTER //
// ./src/components/Cart/Rooms/Rooms.js